import { TripType } from "@constants/home.constants";
import { TRIP_TYPE_TO_UPLIFT_TRIP_TYPE } from "@constants/payment.constant";
import { N0Journey, JourneyOtherFee, Fee } from "@models/booking.models";
import { FlightInformationCardCopy } from "@models/cms/flight-information-card.model";
import { UpliftAirReservation } from "../typings/uplift";
import {N0AvailableJourney} from "@models/responses/availability-response.model";
import {DateTime} from "luxon";
import {MONEY_BACK_GUARANTEE_FLIGHT_DAY_LIMIT} from "@constants/app.constants";
import {AppCopy} from "@models/cms/app.model";

export const createAirReservation = (journeys: N0Journey[] | null, tripType: TripType, otherFees: JourneyOtherFee[] | undefined, flightInformationCopy: FlightInformationCardCopy): UpliftAirReservation[] => {
  if (journeys && journeys.length > 0) {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const journey = journeys[0]!;
    const reservation: UpliftAirReservation = {
      airline_name: journey.operatedByText,
      origin: journey.designator.origin,
      destination: journey.designator.destination,
      trip_type: TRIP_TYPE_TO_UPLIFT_TRIP_TYPE[tripType],
      itinerary: journeys.map((j: N0Journey) => {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const firstSegment = j.segments[0]!;
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const lastSegment = j.segments[j.segments.length - 1]!;
        return {
          departure_apc: firstSegment.designator.origin,
          departure_time: convertToUpliftStringDate(firstSegment.designator.departure),
          arrival_apc: lastSegment.designator.destination,
          arrival_time: convertToUpliftStringDate(lastSegment.designator.arrival),
          fare_class: flightInformationCopy.products[firstSegment.productClass],
          carrier_code: firstSegment.identifier.carrierCode
        }
      }),
      insurance: otherFees?.find(o => o.journeyKey === journey.journeyKey)
        ?.otherFees
        ?.flatMap(f => f.fees)?.filter(f => f.code === 'TINS')?.map((f: Fee, idx: number) => {
          return { id: idx + '_' + 'TINS', price: Math.round(f.price * 100), types: ['cancellation'] }
        }) ?? []
    }
    return [reservation];
  }
  return [];
}

export const convertToUpliftStringDate = (value: string) => {
  const date = new Date(value);
  const year = date.getFullYear();
  const month = ('0' + (date.getMonth() + 1)).slice(-2);
  const day = ('0' + date.getDate()).slice(-2);
  return `${year}${month}${day}`;
}

export const convertToUpliftStringBirthDate = (value: string) => {
  const date = new Date(value);
  const year = date.getFullYear();
  const month = ('0' + (date.getMonth() + 1)).slice(-2);
  const day = ('0' + date.getDate()).slice(-2);
  return `${month}/${day}/${year}`;
}

export const showMoneyBackGuarantee = (
  journeys: (N0AvailableJourney | null)[] = [],
  appCopy: AppCopy | null
): boolean => {
  return (
    journeys.length > 0 &&
    journeys.every((journey) => {
      if (journey) {
        const departureTime = DateTime.fromISO(journey.designator.departure);
        const daysAway = departureTime.diffNow('days').days;
        return (
          daysAway >
          (appCopy?.moneyBackGuaranteeDaysLimit ||
            MONEY_BACK_GUARANTEE_FLIGHT_DAY_LIMIT)
        );
      }
      return false;
    })
  );
}

export const isWithinXDays = (dateStr: string | undefined, days: number = 1): boolean => {
  if (!dateStr) return false;
  const date = new Date(dateStr);
  if (isNaN(date.getTime())) return false;

  const now = new Date();
  const diff = date.getTime() - now.getTime();
  const maxDiff = days * 24 * 60 * 60 * 1000;

  return diff > 0 && diff < maxDiff;
};

